import React from 'react';

type MenuLocale = {
  country: Country;
  primaryLanguage: Language;
  timezone: string;
};

export const MenuLocaleContext = React.createContext<MenuLocale>({
  country: 'FIN',
  primaryLanguage: 'en',
  timezone: '',
});
